/**
 * product-share.js — Bouton « Partager » du bloc sticky (snippets/product-share-button.liquid).
 *
 * Trois tentatives, aucune impasse : feuille de partage native, puis copie dans le
 * presse-papier, puis champ présélectionné que le client copie lui-même.
 *
 * Tracking : un `click_cta` après l'issue, cta_name = share_native | share_cancelled |
 * share_copied | share_manual. L'issue est dans le nom car la balise GTM click_cta ne
 * transmet pas interaction_label à GA4. Le bouton n'a pas de data-cta-name (le délégué du
 * sticky en émettrait un second) et figure dans l'excludeList du tracker générique
 * (tracking-ui-forms.liquid).
 */
(function () {
  'use strict';

  if (window.__productShareBound) return;
  window.__productShareBound = true;

  var COPIED_VISIBLE_MS = 2500;
  // Copie en cours : un double-clic ne copie et ne trace qu'une fois.
  var sharing = false;

  function trackOutcome(outcome) {
    var name = 'share_' + outcome;
    var payload =
      typeof window.mbStickyCtaPayload === 'function'
        ? window.mbStickyCtaPayload(name, 'product_sticky')
        : { cta_name: name, cta_location: 'product_sticky' };
    if (typeof window.trackEvent === 'function') {
      window.trackEvent('click_cta', payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    payload.event = 'click_cta';
    window.dataLayer.push(payload);
  }

  function feedbackFor(root) {
    return {
      root: root,
      text: root.querySelector('[data-share-feedback-text]'),
      input: root.querySelector('[data-share-feedback-input]'),
      live: root.parentNode && root.parentNode.querySelector('[data-share-live]'),
    };
  }

  function feedbackOf(button) {
    var root = button.parentNode && button.parentNode.querySelector('[data-share-feedback]');
    return root ? feedbackFor(root) : null;
  }

  function hideFeedback(feedback) {
    clearTimeout(feedback.root.__shareTimer);
    feedback.root.hidden = true;
    if (feedback.input) feedback.input.hidden = true;
    feedback.text.textContent = '';
    // Vidé pour que le même message soit de nouveau annoncé au clic suivant.
    if (feedback.live) feedback.live.textContent = '';
  }

  // Zone live toujours présente et vidée d'abord : un changement de texte est annoncé.
  function announce(feedback, message) {
    feedback.text.textContent = message;
    if (!feedback.live) return;
    feedback.live.textContent = '';
    requestAnimationFrame(function () {
      feedback.live.textContent = message;
    });
  }

  function showCopied(button) {
    var feedback = feedbackOf(button);
    if (!feedback) return;
    feedback.root.hidden = false;
    if (feedback.input) feedback.input.hidden = true;
    announce(feedback, button.getAttribute('data-share-copied') || '');
    clearTimeout(feedback.root.__shareTimer);
    feedback.root.__shareTimer = setTimeout(function () {
      hideFeedback(feedback);
    }, COPIED_VISIBLE_MS);
  }

  function showManual(button, url) {
    var feedback = feedbackOf(button);
    if (!feedback || !feedback.input) return;
    clearTimeout(feedback.root.__shareTimer);
    feedback.root.hidden = false;
    feedback.input.value = url;
    feedback.input.hidden = false;
    announce(feedback, button.getAttribute('data-share-manual') || '');
    feedback.input.focus();
    feedback.input.select();
  }

  function copyLink(button, url) {
    if (navigator.clipboard && window.isSecureContext) {
      // Même verrou que la feuille native : un double-clic ne copie et ne trace qu'une fois.
      if (sharing) return;
      sharing = true;
      navigator.clipboard
        .writeText(url)
        .then(
          function () {
            showCopied(button);
            trackOutcome('copied');
          },
          function () {
            showManual(button, url);
            trackOutcome('manual');
          },
        )
        .then(releaseSharing, releaseSharing);
      return;
    }
    showManual(button, url);
    trackOutcome('manual');
  }

  function share(button) {
    var url = button.getAttribute('data-share-url') || window.location.href;
    var title = button.getAttribute('data-share-title') || document.title;
    if (typeof navigator.share !== 'function') {
      copyLink(button, url);
      return;
    }
    // Pas de verrou ici : un second appel est rejeté par le navigateur (InvalidStateError), et
    // certaines webviews ne résolvent jamais la promesse, ce qui bloquerait le bouton.
    navigator.share({ title: title, url: url }).then(
      function () {
        trackOutcome('native');
      },
      function (err) {
        var name = err && err.name;
        // Feuille fermée par le client : ce n'est pas un échec, il n'y a rien à copier.
        if (name === 'AbortError') {
          trackOutcome('cancelled');
          return;
        }
        if (name === 'InvalidStateError') return;
        copyLink(button, url);
      },
    );
  }

  function releaseSharing() {
    sharing = false;
  }

  function openFeedback() {
    var root = document.querySelector('[data-share-feedback]:not([hidden])');
    return root ? feedbackFor(root) : null;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var button = e.target.closest('[data-share-open]');
    if (button) {
      share(button);
      return;
    }
    var feedback = openFeedback();
    if (feedback && !feedback.root.contains(e.target)) hideFeedback(feedback);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var feedback = openFeedback();
    if (!feedback) return;
    // Le champ masqué avait le focus : le rendre au bouton plutôt qu'au body.
    var hadFocus = feedback.root.contains(document.activeElement);
    hideFeedback(feedback);
    var button = hadFocus && feedback.root.parentNode.querySelector('[data-share-open]');
    if (button) button.focus();
  });
})();
